import PropTypes from "prop-types";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Avatar, Box, ButtonBase } from "@mui/material";

// project imports

import TitleSection from "./TitleSection";
import ProfileSection from "./ProfileSection";


// assets
import { IconMenu2 } from "@tabler/icons";

import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// material-ui

// project imports
import config from "config";
//import Logo from 'ui-component/Logo';
import { MENU_OPEN } from "store/actions";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();
  const defaultId = useSelector((state) => state.customization.defaultId);
  const dispatch = useDispatch();

  ////////////////////////////////////////////////////////////////////////////////

  return (
    <>
      <Box
        sx={{
          width: 228,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
        }}
      >
        <ButtonBase
          disableRipple
          onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })}
          //component="span"
          sx={{
            display: { xs: "none", md: "flex" },
            flexGrow: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
          component={Link}
          to={config.defaultPath}
        >
          <img
            src="/images/PHUWADOL-LOGO.svg"
            alt="PHUWADOL-LOGO"
            style={{ width: "auto", height: "60px", paddingRight: "18px" }}
          />

         
        </ButtonBase>

        <ButtonBase sx={{ borderRadius: "12px", overflow: "hidden" }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: "all .2s ease-in-out",
              background: theme.palette.secondary.light,
              color: theme.palette.secondary.dark,
              "&:hover": {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light,
              },
            }}
            onClick={handleLeftDrawerToggle}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
      </Box>

      <TitleSection />

      <Box sx={{ flexGrow: 1 }} />

      <ProfileSection />
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
};

export default Header;
